export default defineNuxtRouteMiddleware(async (to, from) => {  
  const visitorSession = useVisitorSession()
  await visitorSession.restore()
})
